import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { renewpassword_request_url } from '../Utilities/apiUrl';
import consts from '../Utilities/appConsts.json';
import useIframeParams from './useIframeParam';
import useLoader from './useLoader';

function useChangePassword() {
  const [password, setPassword] = useState<string>('');
  const [secondPassword, setSecondPassword] = useState<string>('');
  const [isShowHelperText, setIsShowHelperText] = useState<boolean>(false);
  const channel = useIframeParams('channel') || "";
  const temptoken = useIframeParams('temptoken') || "";
  const navigate = useNavigate();
  const { loading, showLoading, hideLoading, LoaderComponent } = useLoader();

  const changePassword = async (token: string | null) => {
    if (password === secondPassword) {
      const encodedPassword = encodeURIComponent(password);
      showLoading();
      const data = await fetch(`${renewpassword_request_url}&password=${encodedPassword}&token=${token}&channel=${channel}&temptoken=${temptoken}`);
      const data1 = await data.json();
      hideLoading();
      if (data1.isValid) {
        navigate(`/sucssespassword?channel=${channel}&temptoken=${temptoken}`);
      }
    } else {
      setIsShowHelperText(true);
    }
  };

  useEffect(() => {
if(password !== secondPassword){
  setIsShowHelperText(true);
}
  },[secondPassword]);

  return {
    password,
    setPassword,
    secondPassword,
    setSecondPassword,
    isShowHelperText,
    changePassword,
    setIsShowHelperText,
    loading,
    LoaderComponent,
  };
}

export default useChangePassword;
